import { ProjectModel, ProjectPermissions } from "../api/project";
import { RasterAttributes } from "./model";

export enum GeoTiffRenderingMode {
  Value = "value",
  RGB = "rgb"
}

export enum ShapefileFileType {
  GeoTiff = "GeoTiff",
  Shapefile = "Shapefile",
  ShapefileLower = "shapefile"
}

export interface ProjectWithPermission extends ProjectModel {
  permission?: ProjectPermissions;
}

export type MoveTypeWellInput = {
  newProjectId: string;
};

export interface IShapefileNode {
  name: string;
  shapefileId: string;
  shapefileNodeId: string;
  projectShapefileId?: string;
  projectId: string;
  editMode: boolean;
  title: string;
  type: string;
  key: string;
  children: [];
  order?: number;
}

export interface IShapefile {
  name: string;
  owner: string;
  key: string;
  projectId: string;
  shapefileId: string;
  shapefileNodeId: string;
  projectShapefileId?: string;
  color: string;
  fillColor: string;
  strokeColor: string;
  thickness: number;
  lineStyle?: string;
  fillPattern?: string;
  opacity: number;
  editMode: boolean;
  visibility?: string;
  properties?: string[];
  fileType: ShapefileFileType;
  rasterAttributes?: RasterAttributes;
  renderingMode?: GeoTiffRenderingMode;
  tilesStatus?:
    | "pending"
    | "processing"
    | "processing_high_zoom"
    | "completed"
    | "failed"
    | null;
  tilesReady?: boolean | null;

  title: string;

  type: string;
  children: [];
}
